import { render, staticRenderFns } from "./new_building.vue?vue&type=template&id=08997456&scoped=true"
import script from "./new_building.vue?vue&type=script&lang=js"
export * from "./new_building.vue?vue&type=script&lang=js"
import style0 from "./new_building.vue?vue&type=style&index=0&id=08997456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08997456",
  null
  
)

export default component.exports